export * from './PropayTab';

export default {
    // edit: PropayEdit,
};
